import { filter } from 'ramda';
import { handleActions } from 'redux-actions';
import { set } from 'seamless-immutable';

import {
  SET_ENTRIES,
  SET_INVITE,
  SET_ROUTINES_CAMPAIGN,
  SET_TEMPLATE,
} from './actions';

export const INITIAL_STATE = {
  entries: [],
  invite: null,
  template: null,
};

export const actionMap = {
  [SET_ENTRIES]: (state, { payload: entries }) => {
    const removeCommonEntries = filter(
      (entry) => !entries.some((e) => e.sys.id === entry.sys.id)
    );

    const oldEntries = removeCommonEntries(state.entries);
    const combinedEntries = entries.concat(oldEntries);

    return set(state, 'entries', combinedEntries);
  },

  [SET_INVITE]: (state, { payload: invite }) => ({
    ...state,
    invite,
  }),

  [SET_ROUTINES_CAMPAIGN]: (state, { payload: routinesCampaign }) => ({
    ...state,
    routinesCampaign,
  }),

  // NOTE: For some reason setting this to be Immutable breaks the template
  // object. My suspicion is a bizarre interplay between the `esm` module and
  // `seamless-immutable`. This should only ever be set server side and never
  // updated.
  [SET_TEMPLATE]: (state, { payload: template }) => ({
    ...state,
    template,
  }),
};

export default handleActions(actionMap, INITIAL_STATE);
